import LoginComponent from '../login-component';
import LoginCheckbox from '../ui-elements/login-checkbox';
import FormActions from '../../logic/form-actions';
import RedirectUrls from '../../constants/redirect-url';
import ParamStore from '../../logic/stores/param-store';
import {localize} from '../../infrastructure/localization';

import './terms-of-service.scss';

export default class TermsOfService extends LoginComponent {

    constructor(props) {
        super(props);
    }

    get error() {
        return this.state.loginModel.validation.errors.acceptTerms;
    }

    get text() {
        return localize('form-components.terms-of-service-a')

            .replace('{0}', '<a target="_blank" href="' + RedirectUrls.jm.register.termsOfService.replace('{lang5}', this.state.paramModel.lang5) +
                '" onclick="event.stopPropagation();jwfLogin._Api.termsLinkClicked('+ this.state.componentId +')" data-gaeventcategory="' + this.state.paramModel.tracking.ga.termsLink.category + '" data-gaeventaction="' + this.state.paramModel.tracking.ga.termsLink.action + '">')
            .replace('{1}', '</a>')
            .replace('{2}', '<a target="_blank" href="' + RedirectUrls.jm.register.privacyPolicy.replace('{lang5}', this.state.paramModel.lang5) +
                '" onclick="event.stopPropagation();jwfLogin._Api.privacyLinkClicked('+ this.state.componentId +')" data-gaeventcategory="' + this.state.paramModel.tracking.ga.privacyLink.category + '" data-gaeventaction="' + this.state.paramModel.tracking.ga.privacyLink.action + '">')
            .replace('{3}', '</a>')
            .replace('{4}', '<a href="javascript: void(0)" onclick="event.stopPropagation();jwfLogin._Api.showProductInformation('+ this.state.componentId +')" data-gaeventcategory="' + this.state.paramModel.tracking.ga.chooseOtherwiseLink.category + '" data-gaeventaction="' + this.state.paramModel.tracking.ga.chooseOtherwiseLink.action + '">')
            .replace('{5}', '</a>');
    }

    render () {
        return (
            <div className="terms-of-service-placeholder">
                <LoginCheckbox
                    componentId={this.state.componentId}
                    checked={this.state.loginModel.acceptTerms}
                    onChange={(e) => FormActions.changeAcceptTerms(this.state.componentId)}
                    label={this.text}
                    error={this.error}
                    gaEventCategory={this.state.paramModel.tracking.ga.termsCheckBox.category}
                    gaEventAction={this.state.paramModel.tracking.ga.termsCheckBox.action} />
            </div>
        )
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/form-components/terms-of-service.jsx
 **/